export const ApiErrorMessage =
  'It’s not you, it’s us. Please refresh the page.';
